import { useState, useEffect } from "react"
import NPSQuestionnaireFirstStep from "./NPSQuestionnaireFirstStep"
import NPSQuestionnaireSecondStep from "./NPSQuestionnaireSecondStep"
import NPSQuestionnaireThirdStep from "./NPSQuestionnaireThirdStep"
import * as NPSQuestionnaireService from "../../Services/NPSQuestionnaireService/NPSQuestionnaireService"
import metropolisLogo from "../../Images/metropolis-logo.png"
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from "react-router-dom"
import "./NPSQuestionnaire.css"
import NPSQuestionnaireAlreadySubmitted from "./NPSQuestionnaireAlreadySubmitted"
import LoadingSpinnerComponent from "../Loader/LoadingSpinnerComponent"
import NPSQuestionnaireSubmitted from "./NPSQuestionnaireSubmitted"

const extractPartnerIdFromLocalStorage = () => {
    try {
        const persistRoot = localStorage.getItem('persist:root');

        if (persistRoot) {
            const parsedRoot = JSON.parse(persistRoot);

            const partnerAccountDetails = parsedRoot.Partner_Account_Details;

            if (partnerAccountDetails) {
                const parsedPartnerData = JSON.parse(partnerAccountDetails);
                const partnerId = parsedPartnerData.Id;

                return partnerId;
            } else {
                //console.log('No Partner_Account_Details found in persist:root');
            }
        } else {
            //console.log('No persist:root found in localStorage');
        }
    } catch (error) {
        console.error('Error extracting MHL_Client_Code:', error);
    }
    return null;
};

const NPSQuestionnaire = () => {
    const [selectedRating, setSelectedRating] = useState(null)
    const [formSteps, setFormSteps] = useState(null)
    const [feedback, setFeedback] = useState("")
    const [selectedReasons, setSelectedReasons] = useState([])
    const [partnerId, setPartnerId] = useState('')
    const [loading, setLoading] = useState(false)
    const [cameFromSecondStep, setCameFromSecondStep] = useState(false);

    const navigate = useNavigate()

    const reasonToPayloadKeyMap = {
        "Logistics pickup and support": "MHL_Logistics_assistants_behaviour_and__c",
        "Timely supply of material": "MHL_Timely_supply_of_material__c",
        "Test turnaround time (TAT)": "MHL_Test_trunaround_time_TAT__c",
        "Frequency of sales representative meetings": "MHL_Frequency_of_sales_representative__c",
        "Knowledge and communication of Customer care advisors": "MHL_Knowledge_and_communication_of__c",
        "Query / Complaint resolution quality": "Query__c",
        "Received bill / Invoices on time": "MHL_Received_bill_invoices_on_time__c"
    }

    const getNPSFeedbackOfCurrentMonth = () => {
        //debugger
        setLoading(true)

        NPSQuestionnaireService.GetNPSFeedbackOfCurrentMonth()
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {
                    setFormSteps("alreadySubmitted")
                } else {
                    setFormSteps("firstStep")
                    //console.log(data.ResponseMessage);
                }
            })
            .catch()
            .finally(() => { setLoading(false) });
    }

    useEffect(() => {
        const response = extractPartnerIdFromLocalStorage();
        setPartnerId(response);

        getNPSFeedbackOfCurrentMonth()

    }, []);

    const handleFirstStepClick = (rating) => {
        setSelectedRating(rating)
        if (rating === "Un happy" || rating === "Neutral") {
            setFormSteps("secondStep")
            setCameFromSecondStep(true);
        } else {
            setFormSteps("thirdStep")
            setCameFromSecondStep(false)
        }
        //console.log("Selected rating:", rating);
    }

    const handleSecondStepClick = () => {
        setFormSteps("thirdStep")
    }

    const handleBackBtn = () => {
        if (formSteps === "secondStep") {
            setFormSteps("firstStep");
        } else if (formSteps === "thirdStep") {
            if (cameFromSecondStep) {
                setFormSteps("secondStep");
            } else {
                setFormSteps("firstStep");
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault()

        setLoading(true)

        const reasonFlags = {};
        for (const reason in reasonToPayloadKeyMap) {
            const key = reasonToPayloadKeyMap[reason];
            reasonFlags[key] = selectedReasons.includes(reason);
        }

        const payload = {
            Account__c: partnerId,
            MHL_FeedBack__c: selectedRating,
            ...reasonFlags,
            MHL_NPS_Comments__c: feedback
        }

        NPSQuestionnaireService.SaveNPSFeedback(payload)
            .then(({ data }) => {
                //debugger;
                if (data.IsSuccess) {
                    toast.success("Feedback saved succesfully!");
                    setFormSteps("submitted")
                } else {
                    toast.error("Something went wrong")
                    console.error(data.ResponseMessage);
                }
            })
            .catch(() => console.error("Something went wrong."))
            .finally(() => { setLoading(false) });


    }

    return (
        <>
            <Toaster position="top-center" reverseOrder={false} />
            <div className="nps-feedback-form-wrapper">
                <div className="nps-feedback-form d-flex flex-column">

                    {loading && <LoadingSpinnerComponent />}

                    {formSteps === "firstStep" ? (
                        <NPSQuestionnaireFirstStep handleFirstStepClick={handleFirstStepClick} selectedRating={selectedRating} setSelectedRating={setSelectedRating} />
                    ) : formSteps === "secondStep" ? (
                        <NPSQuestionnaireSecondStep handleSecondStepClick={handleSecondStepClick} selectedReasons={selectedReasons} setSelectedReasons={setSelectedReasons} handleBackBtn={handleBackBtn} />
                    ) : formSteps === "thirdStep" ? (
                        <NPSQuestionnaireThirdStep handleThirdStepClick={handleSubmit} feedback={feedback} setFeedback={setFeedback} handleBackBtn={handleBackBtn} handleSubmit={handleSubmit} />
                    ) : formSteps === "submitted" ? (
                        <NPSQuestionnaireSubmitted />
                    ) : formSteps === "alreadySubmitted" ? (
                        <NPSQuestionnaireAlreadySubmitted />
                    ) : null}

                </div>
            </div>
        </>
    )
}

export default NPSQuestionnaire